export default __webpack_public_path__ + "static/media/src3.cb6a0101.mp3";